export default __webpack_public_path__ + "static/media/holyspirit.06d457a2.jpg";